import { get, put, patch, post } from './network';

// Get landing page settings
const getSettings = () => {
  return get('homepage-settings');
};

// Update all settings
const updateSettings = (payload) => {
  return put('homepage-settings', payload);
};

// Toggle landing page on/off
const toggleLandingPage = (enabled) => {
  return patch('homepage-settings/toggle', { enabled });
};

// Update section theme
const updateSectionTheme = (sectionKey, themeData) => {
  return patch(`homepage-settings/theme/section/${sectionKey}`, themeData);
};

// Update global theme
const updateGlobalTheme = (themeData) => {
  return patch('homepage-settings/theme/global', themeData);
};

// Reset theme to defaults
const resetTheme = () => {
  return post('homepage-settings/theme/reset');
};

export default {
  getSettings,
  updateSettings,
  toggleLandingPage,
  updateSectionTheme,
  updateGlobalTheme,
  resetTheme
};